import React from 'react';
import ExtjsReact from 'app/common/utils/ExtReact';
import { debounce } from 'lodash';

function Wrapper({ listConfig, view }) {
    return (
            <ExtjsReport
                view={view}
                config={{
                    list: listConfig.list,
                    list_columns: listConfig.listData,
                    list_permissions: listConfig.listPermissions
                }}
                className="tl-gridpanel"
                style={{ flex: 1 }}
            />
    )
}

export default Wrapper;


class ExtjsReport extends ExtjsReact {
    previousSearchText = ""
    renderExtjsCmp(props = this.props) {
        this.view = props.view;
        this.extjsCmp = showExtjsReport(props.view, props.config, this.renderTo)
        window.appStore.currentViewStore = this;
    }

    componentWillReceiveProps(props) {
        // const me = this;
        // console.log(props);
        if (this.extjsCmp) {
            this.extjsCmp.destroy?.();
            this.previousSearchText = "";
        }
        this.renderExtjsCmp(props);
        // this.extjsCmp = showExtjsReport(props.view, props.config, this.renderTo)
    }

    executeActionCommand(command) {
        this.extjsCmp.executeActionCommand(command);
    }

    getSearchCriteriaForColumns(columns, searchValue) {
        let me = this,
            searchCriteria = me.getSearchCriteriaForColumn({
                alias_name: 'id'
            }, searchValue);

        columns.forEach((column) => {
            if (column.alias_name !== "createdBy") {
                let searchCriteriaForColumn = me.getSearchCriteriaForColumn(column, searchValue);
                searchCriteria = searchCriteria ? searchCriteria + " OR " + searchCriteriaForColumn : searchCriteriaForColumn;
            }
        });
        return searchCriteria;
    }

    getSearchCriteriaForColumn(column, searchValue) {
        var me = this;
        return " ( " + Util.toUpperCamelCase(me.props.config.list.name) + "." + column.alias_name + " LIKE '%" + searchValue + "%' )";
    }

    handleQuickSearchChange = debounce((searchText) => {
        if (this.previousSearchText === searchText) {
            return;
        }
        this.previousSearchText = searchText;
        const criteria = this.getSearchCriteriaForColumns(this.props.config.list_columns, searchText);

        this.extjsCmp.searchView(criteria);
    }, 500)
}

function showExtjsReport(view, config, renderTo) {
    const viewPermissions = Ext.create("TL.list.permissions.Permissions", {
        permissions: config?.list_permissions
    });
    const me = {
        permissions: viewPermissions ?? {}
    };
    window.serverUrl = ""

    const currentUserViewPanel = TL.list.views.ViewsFactory.get(view.type, {
        config: config,
        viewConfig: view,
        renderTo: renderTo,
        height: "100%",
        width: "100%",
        // cls: view.type !== "dashboard" ? 'tl-round' : "",
        permissions: me.permissions,
        // viewContainer: me,
        listData: config.list,
        customEvents: config.custom_events, // todo check this;
        hideDefaultColumns: true, //me.doHideDefaultColumns(),
        addButtonText: "New Entry", //me.getAddButtonText(true),
        listeners: {
            'selectionchange': function (view, records) {
                this.selectedRecords = records;
                this.updateCountInSendMailButton();

                if (records.length > 0) {
                    this.setToolbarButtonsVisibility('view-buttons', false);
                    this.setToolbarButtonsVisibility('common-buttons', false);
                    this.down("#advanced-search-btn").setVisible(false);
                    this.down("#search-input").setVisible(false);
                    this.setToolbarButtonsVisibility('table-buttons', false);
                    if (this.permissions.canSendEmail()) {
                        this.down('#send-mail-btn').setVisible(true);
                    }
                } else {
                    this.down('#send-mail-btn').setVisible(false);
                    this.setToolbarButtonsVisibility('view-buttons', true);
                    this.setToolbarButtonsVisibility('table-buttons', true);
                    this.setToolbarButtonsVisibility('common-buttons', true);
                }
                //if (this.isMainView()) {
                if (this.permissions.canEdit()) {
                    this.down('#edit-btn-' + this.id).setVisible(records.length && records.length == 1);
                    this.down('#bulk-edit-btn-' + this.id).setVisible(records.length > 1);
                    this.down('#bulk-edit-btn-' + this.id).setText("bulk edit (" + records.length + ")");
                    this.down('#unselect-btn-' + this.id).setVisible(records.length > 0);
                    this.down('#unselect-btn-' + this.id).setText("unselect (" + records.length + ")");

                }

                // if (this.permissions.canEdit()) {
                //     this.down('#edit-btn-' + this.id).setVisible(records.length && records.length == 1);
                //     this.down('#bulk-edit-btn-' + this.id).setVisible(records.length > 1);
                //     this.down('#bulk-edit-btn-' + this.id).setText("bulk edit (" + records.length + ")");
                // }
                if (this.permissions.canAdd()) {
                    // this.down('#separator-btn-copy' + this.id).setVisible(records.length && records.length == 1);
                    this.down('#copy-btn-' + this.id).setVisible(records.length && records.length == 1);
                }

                if (this.permissions.canEdit() && this.permissions.canDelete()) {
                    // this.down('#separator-btn-' + this.id).setVisible(records.length);
                }
                if (this.permissions.canDelete()) {
                    this.down('#remove-btn-' + this.id).setVisible(records.length);
                }
                if (this.down('#more-actions-btn-' + this.id)) {
                    // this.down('#more-separator-btn-' + this.id).setVisible(records.length);
                    this.down('#more-actions-btn-' + this.id).setVisible(records.length);
                }
                //} else {
                //    this.hideButtons();
                //}
            },
            'edit': function (recordId) {
                //this.editRecordById(recordId);
                window.appStore?.containerStore?.showForm(
                    "Edit",
                    recordId
                  );
            },
            'row-id-click': function (row, columns) {
                me.getRowDataAndShowSummaryRowView(row, columns, true)
            },
            'showcomments': function (recordId, element) {
                window.appStore.containerStore.commentsPopoverData = {
                    isCommentsPopoverOpen: true,
                    commentsPopoverRowId: recordId,
                    commentsPopoverAnchorEl: element
                }
                //this.showComments(recordId);
            },
            'showcomments-in-summary-row-view': function (row, columns) {
                me.getRowDataAndShowSummaryRowView(row, columns, true)
            },
            'addrow': function (rowData, title) {
                window.appStore?.containerStore?.showForm((title || "New"), "", "", rowData);
                //this.showForm((title || "New"), "", "", rowData);
            },
            'headerfilter': function (listCfg, columnCfg, headerCt) {
                this.filtersToolbar.getFilterComponent(listCfg, columnCfg, headerCt);
            },
            'viewconfigchanged': function (view, doSave, cb) {
                doSave = doSave || false;

                // if (me.summaryListView) {
                //     let baseCriteria = view.criteria;
                //     if (me.currentUserViewPanel.getFiltersCriteria) {
                //         // baseCriteria = me.currentUserViewPanel.getFiltersCriteria(true)
                //     }
                //     me.summaryListView.setBaseCriteria(baseCriteria);
                // }
                // me.workflowStatusFilterButtons.setCurrentView(me.getCurrentView());

                if (doSave && view.id > 0) {
                    this.saveView(this.config.list.id, view, true, false, cb);

                    me.down("#hide_fields").setData({
                        view: view,
                        listColumns: this.config.list_columns
                    })

                } else {
                    if (view.is_main_view == 1) {
                        view.is_main_view = 0;
                        view.is_system = 0;
                        view.is_default = 0;
                        view.name = "";
                        view.id = 0;
                    }
                    // this.onViewChange(view);
                }
                // this.filtersPanel.setBaseCriteria(view.criteria);
            },
            'viewadded': function () {
                me.getViews();
            },
            'viewchanged': function (view) {
                me.getViews(function () {
                    me.showView(view);
                });
            },
            viewedit: function (viewId) {
                this.showEditViewFromIdForDashboard(viewId)
            },
            "deleterecord": function (record) {
                this.removeRecord([record])
            },
            // "triggerevent": this.executeEventActions,
            "triggerevent": function (event, records) {
                window.appStore?.containerStore?.executeReportActions(event, records);
            },
            viewclick: function (view) {
                this.getView(view.id, Ext.bind(function (data) {
                    this.showView(data);
                }, this));

            },
            // 'filterchange': function (columnCfg, selectedRecords) {
            // var me = this;
            // me.updateFiltersInSummaryView(columnCfg.id, selectedRecords);
            // if (me.summaryListView.cmp.$$("summary_filter_list_view")) {
            //     me.summaryListView.cmp.$$("summary_filter_list_view").filterColumns.refresh();
            // }
            // debugger;
            // },
            // "newentry": me.addRecord,
            'row_added': row => {
                me.down("#viewAggregationPopup").store.refreshData();
                me.workflowStatusFilterButtons?.setCurrentView(me.getCurrentView())
            },
            'row_edited': row => {
                me.down("#viewAggregationPopup").store.refreshData();
                me.workflowStatusFilterButtons?.setCurrentView(me.getCurrentView())
            },
            'refresh_click': () => {
                me.down("#viewAggregationPopup").store.refreshData();
                me.workflowStatusFilterButtons?.setCurrentView(me.getCurrentView())
            },
            'runview': (view) => {
                this.runView(view);
            },
            'afterrender': () => {
                // viewPort.getEl().unmask();
            },
            'filter_criteria_changed': function (criteria, filterCount) {
                currentUserViewPanel.searchView(criteria);
            },
            // scope: this
        }
    });

    return currentUserViewPanel;
}